import React from 'react';
import PropTypes from 'prop-types';

const bannerCSS = {
  paddingLeft: '10px',
  paddingTop: '8px',
  minHeight: '52px',
  borderBottom: ' #f93 2px solid',
  fontFamily: '"Trebuchet MS", Arial, Helvetica, sans-serif',
  fontSize: '35px',
  fontWeight: 'bold',
  color: '#5b0013',
  marginTop: 0,
  marginBottom: 0,
  background: '#f0e9d1' /* Old browsers */,
  // eslint-disable-next-line no-dupe-keys
  background:
    '-moz-linear-gradient( top, #f0e9d1 0%, #ffde7c 100%)' /* FF3.6-15 */,
  // eslint-disable-next-line no-dupe-keys
  background:
    '-webkit-linear-gradient( top, #f0e9d1 0%, #ffde7c 100%)' /* Chrome10-25,Safari5.1-6 */,
  // eslint-disable-next-line no-dupe-keys
  background:
    'linear-gradient( to bottom, #f0e9d1 0%,#ffde7c 100%)' /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */,
};

// eslint-disable-next-line func-names
const AppBanner = function (props) {
  const { appTitle } = props;
  return (
    <div style={bannerCSS} id='umnHeaderAppBanner'>
      {appTitle}
    </div>
  );
};

AppBanner.propTypes = {
  appTitle: PropTypes.string.isRequired,
};

export default AppBanner;
